$(document).ready(function()
{
	// Quick order form
	$('#quick-order').on('submit', function(e)
	{
		e.preventDefault();

		var data = [];
		$(this).find('.quickorder.row').each(function()
		{
			var variantID = parseInt($(this).find('input[name="id"]').val());
			var quantity = $(this).find('input[name="quantity"]').val();

			if (variantID && quantity)
			{
				data.push({ id: variantID, quantity: quantity });
			}
		});

		if (data.length)
		{
			$.post('/cart/add.js', { items: data })
				.done(function()
					{
						window.location.href = '/cart';
					}
				);
		}

	});

});